module.exports = __webpack_public_path__ + "static/media/thumbnail.c60754db.jpg";